import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    fontFamily: 'TWKLausanne',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  container: {
    flex: 1,
    paddingHorizontal: 24,
  },

  table: { paddingHorizontal: 0, marginTop: 0 },

  note: {
    fontWeight: 700,
    fontSize: 10,
    textTransform: 'uppercase',
    marginBottom: 2,
    color: colors.neutral900,
  },

  noteContainer: {
    marginTop: 10,
  },

  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral900,
  },

  bottomContainer: {
    maxWidth: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },

  productTable: { paddingHorizontal: 0, marginTop: 0 },

  productTablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 20,
  },
});
